/**
 * Feature 268 — who this plate is for, on the kitchen display.
 *
 * The twin of the app's chip, and deliberately as empty-headed: what to draw,
 * and whether to draw at all, is `shouldShowDinerTag` in the shared module.
 * This package has no renderer under test (see jest.config.cjs), so a decision
 * written here is a decision nothing can check.
 *
 * `enabled` is passed in by whoever owns the client config on the surface —
 * the card body, the comanda — and never fetched here.
 */
import { dinerTagColor, shortenDinerTag, shouldShowDinerTag } from '@shared/kds/diner-tag';
import { useTranslation } from '../i18n';

/** A wall display is read from across the pass: fewer characters, larger type. */
const MAX_CHARS_ON_SCREEN = 12;

interface DinerTagChipProps {
  item: { subAccount?: string | null };
  enabled?: boolean;
}

export default function DinerTagChip({ item, enabled = false }: DinerTagChipProps) {
  const { t } = useTranslation();
  const tag = shouldShowDinerTag(item, enabled);
  if (tag === null) return null;

  const colour = dinerTagColor(tag);

  return (
    <span
      className="text-kds-badge font-bold px-2 py-0.5 rounded-full border shrink-0"
      style={{ color: colour, borderColor: colour, backgroundColor: `${colour}22` }}
      title={t('kds.dinerTag.title', 'Commensale {{tag}}', { tag })}
    >
      {shortenDinerTag(tag, MAX_CHARS_ON_SCREEN)}
    </span>
  );
}
